import {
  Box,
  Grid,
  Paper,
  Typography,
  Avatar,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Alert,
  Divider,
  ButtonBase
} from "@mui/material";
import {
  Email,
  Add,
  Send,
  CorporateFare,
  Groups,
  RocketLaunch,
  EventAvailable,
  AddCircle,
  PersonAdd,
  Edit,
  VolunteerActivism,
  DomainAdd,
  HowToReg,
  Assessment,
  ArrowForward,
} from "@mui/icons-material";
import { Radio, RadioGroup, FormControlLabel, Checkbox } from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Tooltip from "@mui/material/Tooltip";
import userPlaceholderImage from "../../../images/user.png";
import { keyframes } from "@mui/material/styles";
import { HourglassEmpty } from "@mui/icons-material";
// import ComingSoon from "../../../components/common/ComingSoon";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import DastakLogo from "../../../images/ProgramBaskets/DastakLogo.png";

import { useTheme } from "@mui/material/styles";
import { usePermission } from "../../../permissions/usePermission";
import { extractDesignationLabels } from "../../../utils/designationUtils";
import { getPublicS3Url } from "../../../utils/s3PublicUrl";
import ApiCallService from "../../../Service/ApiCallService";
import ReactTable from "../../../components/common/ReactTable";

import { isOnline } from "../../../utils/networkCheck";
import OfflineModal from "../../../components/common/OfflineModal";

const pulseFloat = keyframes`
  0% {
    opacity: 0.7;
    transform: translateY(0);
  }
  50% {
    opacity: 1;
    transform: translateY(-4px);
  }
  100% {
    opacity: 0.7;
    transform: translateY(0);
  }
`;

const pulse = keyframes`
  0% { opacity: 0.7; }
  50% { opacity: 1; }
  100% { opacity: 0.7; }
`;

export default function Dashboard({ pendingVerification = false }) {
  const navigate = useNavigate();
  const userId = localStorage.getItem("userId");
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [hasChapterMembership, setHasChapterMembership] = useState(false);
  const [isChapterMembershipLoading, setIsChapterMembershipLoading] =
    useState(true);
  const [chapterAssignments, setChapterAssignments] = useState([]);
  const [chapterList, setChapterList] = useState([]);
  const [chapterDialogOpen, setChapterDialogOpen] = useState(false);
  // const [chapterMembershipAnswer, setChapterMembershipAnswer] = useState(null);
  // const [joinExistingChapterAnswer, setJoinExistingChapterAnswer] = useState(null);
  const [chapterRoles, setChapterRoles] = useState([]);
  const [selectedChapterId, setSelectedChapterId] = useState("");
  const [selectedChapterRoleId, setSelectedChapterRoleId] = useState("");
  const [isAssigningChapter, setIsAssigningChapter] = useState(false);
  const [chapterAssignmentMessage, setChapterAssignmentMessage] =
    useState(null);
  const userData = useSelector((state) => state.user.userDetails);
  const isAdmin = useSelector((s) => ["HeadOffice", "SuperAdmin", "Admin"].includes(s?.user?.userDetails?.userRole));
  const [viewMode, setViewMode] = useState("home");
  const [dialogView, setDialogView] = useState("chapters");
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [districtChapters, setDistrictChapters] = useState([]);
  const [chapterPage, setChapterPage] = useState(1);
  const [chapterTotal, setChapterTotal] = useState(0);
  const [isChapterLoading, setIsChapterLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [isRestrictedNECMember, setIsRestrictedNECMember] = useState(false);
  const [offlineBannerOpen, setOfflineBannerOpen] = useState(false);
  const permissionsState = useSelector((state) => state.permissions);
  const { isSuperAdmin: isSuperUser, can, canByKey } = usePermission();
  const isSelfServiceUser =
    userData?.filledBy === "SELF" ||
    localStorage.getItem("filledBy") === "SELF";
  const isSelfUser = Boolean(userId);
  const canEditOwnProfile =
    isSelfUser || isSelfServiceUser || canByKey("USER_MANAGEMENT_USERS_UPDATE");
  const canViewOwnJourney =
    isSelfUser || isSelfServiceUser || canByKey("USER_MANAGEMENT_JOURNEY_VIEW");
  const designationLabels = extractDesignationLabels(permissionsState);
  const adminModules = Array.isArray(userData?.adminModules)
    ? userData.adminModules
    : [];
  const adminDesignationLabels = [];
  if (adminModules.includes("NETWORK")) {
    adminDesignationLabels.push("Network Admin");
  }
  if (adminModules.includes("PROGRAM")) {
    adminDesignationLabels.push("Program Admin");
  }
  const adminDesignationText =
    adminDesignationLabels.length > 0
      ? adminDesignationLabels.join(" • ")
      : "Admin";
  const normalizeRole = (role) =>
    String(role || "")
      .trim()
      .toLowerCase()
      .replace(/[\s_-]+/g, "");
  const roleKey = normalizeRole(userData?.userRole);
  const superRoleLabel =
    userData?.userRoleLabel ||
    (roleKey === "superadmin"
      ? "Super Admin"
      : roleKey === "superuser"
        ? "Super User"
        : roleKey === "headoffice"
          ? "Head Office"
          : null);
  const designationText = superRoleLabel
    ? superRoleLabel
    : userData?.userRole === "Admin"
      ? adminDesignationText
      : designationLabels.length > 0
        ? designationLabels.join(" • ")
        : "-";
  const canViewProgramInterestDashboard =
    isSuperUser || ["Admin", "SuperAdmin", "SuperUser"].includes(userData?.userRole);

  // const permissions = useSelector((state) => state.permissions.permissions);
  // useEffect(() => {
  //   console.log("User Permissions updated:", permissions);
  // }, [permissions.length]);

  const isProd = false;

  const paragraphs = [
    "Great to see you again! Your chapters, programs, and events are right here, ready for you to explore and manage effortlessly.",
    "Check out the latest updates from your chapters and see how your programs are progressing today.",
    "Don't forget to engage with your events and connect with members for maximum impact.",
  ];

  const [currentPara, setCurrentPara] = useState(0);

  useEffect(() => {
    window.scrollTo({ top: 0, behaviour: "smooth" });
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentPara((prev) => (prev + 1) % paragraphs.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    let isActive = true;

    const fetchCouncilMembership = async () => {
      if (!userId) return;
      try {
        const response = await ApiCallService.get("committeeMembers/myCouncilMembership?councilCode=NEC");
        const responseData = response?.data?.data || response?.data || response;

        if (responseData) {
          const { council, membership } = responseData;
          if (
            council?.code === "NEC" &&
            membership?.committeeName === "National Program Head"
          ) {
            if (isActive) setIsRestrictedNECMember(true);
          }
        }
      } catch (error) {
        console.error("Failed to fetch council membership:", error);
      }
    };

    fetchCouncilMembership();

    return () => {
      isActive = false;
    };
  }, [userId]);

  useEffect(() => {
    let isActive = true;

    const fetchChapterMembership = async () => {
      if (!userId) {
        setHasChapterMembership(false);
        setIsChapterMembershipLoading(false);
        return;
      }

      try {
        setIsChapterMembershipLoading(true);
        const [response, chaptersResponse, rolesResponse] = await Promise.all([
          ApiCallService.get(
            `${process.env.REACT_APP_BASE_URL}/chapter-members/user/${userId}`,
          ),
          ApiCallService.get(
            `${process.env.REACT_APP_BASE_URL}/getAllChapters`,
          ).catch((error) => {
            console.error("Failed to fetch chapter list:", error);
            return [];
          }),
          ApiCallService.get(
            `${process.env.REACT_APP_BASE_URL}/chapter-members/chapterRoles`,
          ).catch((error) => {
            console.error("Failed to fetch chapter roles:", error);
            return [];
          }),
        ]);
        const assignments =
          response?.data?.data ?? response?.data ?? response ?? [];
        const chapters =
          chaptersResponse?.data?.data ??
          chaptersResponse?.data ??
          chaptersResponse ??
          [];
        const roles =
          rolesResponse?.data?.data ??
          rolesResponse?.data ??
          rolesResponse ??
          [];

        if (isActive) {
          setChapterAssignments(Array.isArray(assignments) ? assignments : []);
          setChapterList(Array.isArray(chapters) ? chapters : []);
          setChapterRoles(Array.isArray(roles) ? roles : []);
          setHasChapterMembership(
            Array.isArray(assignments) && assignments.length > 0,
          );
        }
      } catch (error) {
        console.error("Failed to fetch chapter membership:", error);
        if (isActive) {
          setChapterAssignments([]);
          setChapterList([]);
          setHasChapterMembership(false);
        }
      } finally {
        if (isActive) {
          setIsChapterMembershipLoading(false);
        }
      }
    };

    fetchChapterMembership();

    return () => {
      isActive = false;
    };
  }, [userId]);

  const getChapterId = (assignment) => {
    const chapter = assignment?.chapterId ?? assignment?.chapter;
    return typeof chapter === "object" ? chapter?._id : chapter;
  };

  const assignedChapters = chapterAssignments
    .map((assignment) => {
      const populatedChapter =
        typeof assignment?.chapterId === "object"
          ? assignment.chapterId
          : typeof assignment?.chapter === "object"
            ? assignment.chapter
            : null;

      return (
        chapterList.find(
          (chapter) => chapter?._id === getChapterId(assignment),
        ) || populatedChapter
      );
    })
    .filter(Boolean);

  const handleModuleClick = (moduleAction) => {
    if (!isOnline()) {
      setOfflineBannerOpen(true);
      return;
    }

    moduleAction();
  };

  const handleStateChange = async (stateId) => {
    setSelectedState(stateId);
    setSelectedDistrict("");
    setDistricts([]);

    try {
      const response = await ApiCallService.get(`state/${stateId}/district`);

      const districtData =
        response?.data?.data ?? response?.data ?? response ?? [];

      setDistricts(Array.isArray(districtData) ? districtData : []);
    } catch (error) {
      console.error("Failed to fetch districts", error);
    }
  };

  const fetchStates = async () => {
    try {
      const response = await ApiCallService.get(`/states`);

      const stateData =
        response?.data?.data ?? response?.data ?? response ?? [];

      setStates(Array.isArray(stateData) ? stateData : []);
    } catch (error) {
      console.error("Failed to fetch states", error);
    }
  };

  const fetchDistrictChapters = async (districtId, page = 1) => {
    try {
      setIsChapterLoading(true);
      const response = await ApiCallService.get(
        `getAllChapters?districtId=${districtId}`,
      );

      const data = response?.data?.data ?? response?.data ?? [];

      setDistrictChapters(
        data.filter(
          (chapter) => chapter?.location?.district?._id === districtId,
        ),
      );

      setChapterTotal(data?.total || 0);

      setChapterPage(page);
    } catch (error) {
      console.error("Failed to fetch chapters", error);
    } finally {
      setIsChapterLoading(false);
    }
  };

  const handleJoinChapter = (chapter) => {
    const payload = {
      chapterId: chapter._id,
      roleId: "695be7a0984c00c438621eb5",
    };


    setSnackbarMessage(
      `You have successfully joined ${chapter.chapterName} as a Chapter Member`,
    );

    setSnackbarOpen(true);
    closeChapterDialog();
  };

  const resetChapterDialog = () => {
    setDialogView("chapters");
    setSelectedChapterId("");
    setSelectedChapterRoleId("");
    setChapterAssignmentMessage(null);
  };

  const openChapterDialog = () => {
    resetChapterDialog();
    setChapterDialogOpen(true);
  };

  const closeChapterDialog = () => {
    setChapterDialogOpen(false);
    resetChapterDialog();
  };

  const handleAssignChapter = async () => {
    if (!selectedChapterId || !selectedChapterRoleId) {
      setChapterAssignmentMessage({
        severity: "error",
        text: "Please select a chapter and a role.",
      });
      return;
    }

    try {
      setIsAssigningChapter(true);
      setChapterAssignmentMessage(null);
      await ApiCallService.post(
        `${process.env.REACT_APP_BASE_URL}/chapter-members/user/${userId}/assign`,
        { chapterId: selectedChapterId, roleId: selectedChapterRoleId },
      );

      const selectedChapter = chapterList.find(
        (chapter) => chapter?._id === selectedChapterId,
      );
      setChapterAssignments((current) => [
        ...current,
        {
          chapterId: selectedChapter || selectedChapterId,
          roleId: selectedChapterRoleId,
        },
      ]);
      setHasChapterMembership(true);
      setChapterAssignmentMessage({
        severity: "success",
        text: "You have been assigned to the selected chapter.",
      });
    } catch (error) {
      setChapterAssignmentMessage({
        severity: "error",
        text:
          error?.response?.data?.message ||
          error?.message ||
          "Unable to assign the chapter. Please try again.",
      });
    } finally {
      setIsAssigningChapter(false);
    }
  };

  const activities = [
    {
      icon: <AddCircle color="primary" />,
      text: "New chapter created in Mumbai.",
      time: "2 hours ago",
    },
    {
      icon: <PersonAdd color="success" />,
      text: "Rohan Sharma joined the Pune chapter.",
      time: "1 day ago",
    },
    {
      icon: <EventAvailable color="primary" />,
      text: "Annual meet event has been scheduled.",
      time: "3 days ago",
    },
    {
      icon: <AddCircle color="primary" />,
      text: "New chapter created in Mumbai.",
      time: "2 hours ago",
    },
    {
      icon: <PersonAdd color="success" />,
      text: "Rohan Sharma joined the Pune chapter.",
      time: "1 day ago",
    },
    {
      icon: <EventAvailable color="primary" />,
      text: "Annual meet event has been scheduled.",
      time: "3 days ago",
    },
  ];

  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.4 } },
  };

  const activityVariants = {
    hidden: { opacity: 0, x: -20 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.4 } },
  };

  const quickActionVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { delay: 0.4, duration: 0.5, staggerChildren: 0.15 },
    },
  };

  const canViewDashboard = can("CORE", "DASHBOARD", "view");

  const currentPathSegment = window.location.pathname
    .split("/")
    .filter(Boolean)[0];
  const activeDesignationSlug = localStorage.getItem("activeDesignationSlug") || (currentPathSegment &&
    !["dashboard", "chapterDetailsPage"].includes(currentPathSegment) ? currentPathSegment : "");

  const priorityActions = [
    {
      icon: <VolunteerActivism />,
      // eyebrow: "Visit coordination",
      title: "Sadhu-Sadhvi Visit Form",
      text: "Plan and submit visit details",
      path: "/dastak/sadhuSadhviVisitForm",
      // path: activeDesignationSlug
      //   ? `/${activeDesignationSlug}/sadhuSadhviVisitForm`
      //   : "/sadhuSadhviVisitForm",
      gradient: "linear-gradient(135deg, #6A1B9A 0%, #9C27B0 100%)",
      glow: "rgba(156, 39, 176, 0.3)",
    },
    {
      icon: <DomainAdd />,
      // eyebrow: "Grow the network",
      title: "Chapter Creation Form",
      isChapterCreation: true,
      text: "Start a new local chapter",
      path: activeDesignationSlug
        ? `/${activeDesignationSlug}/chapterDetailsPage`
        : "/chapterDetailsPage",
      gradient: "linear-gradient(135deg, #868802 0%, #00a8a0 100%)",
      glow: "rgba(0, 131, 154, 0.3)",
    },
    {
      icon: <HowToReg />,
      // eyebrow: "New registration",
      title: "Dastak Registration Form",
      text: "Register and manage Dastak entries",
      path: activeDesignationSlug
        ? `/${activeDesignationSlug}/dastakForm`
        : "/dastakForm",
      gradient: "linear-gradient(135deg, #D35400 0%, #F39C12 100%)",
      glow: "rgba(243, 156, 18, 0.3)",
      disabled:
        !(hasChapterMembership || ["admin", "superadmin"].includes(roleKey)) ||
        (isChapterMembershipLoading && !["admin", "superadmin"].includes(roleKey)),
    },
    {
      icon: <Assessment />,
      // eyebrow: "Admin dashboard",
      title: "Program Interest Dashboard",
      text: "Review chapter interest for Dastak programs",
      path: activeDesignationSlug
        ? `/${activeDesignationSlug}/dastakProgramInterests`
        : "/dastakProgramInterests",
      gradient: "linear-gradient(135deg, #455A64 0%, #00796B 100%)",
      glow: "rgba(0, 121, 107, 0.3)",
      hidden: !canViewProgramInterestDashboard,
    },
  ].filter((action) => !action.hidden);

  const dashboardCards = [
    {
      icon: (
        <Groups
          sx={{
            color: "#2E7D32",
            height: { xs: "1.20em", sm: "1.35em", md: "1.4em" },
            width: { xs: "1.20em", sm: "1.35em", md: "1.4em" },
          }}
        />
      ),
      iconBg: "#C8E6C9",
      title: "Office-Bearers",
      text: "Connect with members",
      bg: "#E8F5E9",
      path: "/committeeMembersList",
      modulePermission: {
        module: "CORE",
        subModule: "NETWORK",
        action: "view",
      },
      // permission: "COMMITTEE_MANAGEMENT_COMMITTEE_MEMBERS_LIST",
    },
    {
      icon: (
        <CorporateFare
          sx={{
            color: "#1565C0",
            height: { xs: "1.20em", sm: "1.35em", md: "1.4em" },
            width: { xs: "1.20em", sm: "1.35em", md: "1.4em" },
          }}
        />
      ),
      iconBg: "#BBDEFB",
      title: "Chapters",
      text: "Manage local groups",
      bg: "#E3F2FD",
      path: "/chapters",
      modulePermission: {
        module: "CORE",
        subModule: "CHAPTER",
        action: "view",
      },
      // permission: "CHAPTER_MANAGEMENT_CHAPTERS_LIST",
    },
    {
      icon: (
        <RocketLaunch
          sx={{
            color: "#F9A825",
            height: { xs: "1.20em", sm: "1.35em", md: "1.4em" },
            width: { xs: "1.20em", sm: "1.35em", md: "1.4em" },
          }}
        />
      ),
      iconBg: "#FFF9C4",
      title: "Programs",
      text: "Explore initiatives",
      bg: "#FFF8E1",
      // path: "/programs",
      path: "/allProgramBaskets",
      // modulePermission: {
      //   module: "CORE",
      //   subModule: "PROGRAM",
      //   action: "view",
      // },
      // permission: "PROGRAM_MANAGEMENT_PROGRAMS_LIST",
    },
    {
      icon: (
        <EventAvailable
          sx={{
            color: "#C2185B",
            height: { xs: "1.20em", sm: "1.35em", md: "1.4em" },
            width: { xs: "1.20em", sm: "1.35em", md: "1.4em" },
          }}
        />
      ),
      iconBg: "#F8BBD0",
      title: "Calendar",
      text: "View upcoming events",
      bg: "#FCE4EC",
      path: "/events",
      modulePermission: {
        module: "CORE",
        subModule: "CALENDAR",
        action: "view",
      },
      // permission: "CORE_CALENDAR_VIEW",
    },
  ];

  const chapterColumns = [
    {
      field: "chapterName",
      headerName: "Chapter Name",
    },
    {
      field: "location",
      headerName: "Location",
      renderCell: (row) =>
        [row?.location?.district?.districtName, row?.location?.state?.stateName]
          .filter(Boolean)
          .join(", "),
    },
    {
      field: "actions",
      headerName: "Actions",
      disableSort: true,
      disableSearch: true,
      renderCell: (row) => (
        <Button
          variant="contained"
          size="small"
          onClick={() => handleJoinChapter(row)}
        >
          Join
        </Button>
      ),
    },
  ];

  const visibleCards = dashboardCards;

  const displayedActivities = showAll ? activities : activities.slice(0, 3);
  const chapterCreationPath = activeDesignationSlug
    ? `/${activeDesignationSlug}/chapterDetailsPage`
    : "/chapterDetailsPage";

  const handlePriorityAction = (action) => {
    if (action.disabled) return;
    if (action.isChapterCreation) {
      openChapterDialog();
      return;
    }
    navigate(action.path);
  };

  const getChapterDetailsPath = (chapterId) => {
    return `${chapterCreationPath}/${chapterId}`;
  };

  const [chapterMode, setChapterMode] = useState("");
  // "join" | "create"

  const handleSelectChapter = (id) => {
    setSelectedChapterId((prev) => (prev === id ? null : id));

    // clear radio selection when chapter selected
    setChapterMode("");
  };

  // radio change
  const handleModeChange = (value) => {
    setChapterMode(value);

    // clear chapter selection when mode selected
    setSelectedChapterId(null);
  };

  const getActionConfig = () => {
    // if (selectedChapterId) {
    //   return {
    //     label: "Go to Dastak",
    //     action: () => {
    //       closeChapterDialog();
    //       navigate("/dastakForm");
    //     },
    //   };
    // }

    if (chapterMode === "join") {
      return {
        label: "Search Chapter",
        action: () => navigate("/JoinExistingChapter"),
      };
    }

    if (chapterMode === "create") {
      return {
        label: "Create Chapter",
        action: () => {
          closeChapterDialog();
          navigate("/createNewDastakChapter");
        },
      };
    }

    return {
      label: "Continue",
      action: () => { },
      disabled: true,
    };
  };

  const actionConfig = getActionConfig();

  return (
    <motion.div
      initial={{ opacity: 0, y: 15 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <Box
        sx={{
          bgcolor: theme.palette.secondary.main,
          minHeight: "100vh",
          fontFamily: "Poppins, sans-serif",
        }}
      >
        <Box p={4}>
          <Grid container spacing={4}>
            <Grid item xs={12} lg={3}>
              <Paper
                elevation={3}
                sx={{
                  display: "flex",
                  flexDirection: {
                    xs: "column",
                    sm: "row",
                    lg: "column",
                  },
                  p: 1,
                  textAlign: "center",
                  borderRadius: 3,
                  position: "relative",
                  border: "0.5px rgba(168, 168, 168, 0.53) solid",
                  overflow: "hidden",
                }}
              >
                <Box
                  sx={{
                    // backgroundImage: userData?.userImageURL,
                    backgroundImage: `url(${getPublicS3Url(userData?.userImageURL) || userPlaceholderImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    position: "relative",
                    flexShrink: 0,
                    borderRadius: "50%",
                    width: { xs: 180, sm: 170, md: 180, lg: 180 },
                    height: { xs: 180, sm: 170, md: 180, lg: 180 },
                    alignSelf: "center",
                    // mt: 2,
                    overflow: "hidden",
                  }}
                >
                  {/* fade */}
                  {/* <Box
                    sx={{
                      position: "absolute",

                      // Position changes
                      bottom: { xs: 0, sm: 0, lg: 0 },
                      right: { xs: 0, sm: 0, lg: 0 },
                      left: { xs: 0, sm: "auto", lg: 0 },

                      // Size changes
                      height: { xs: 80, sm: "100%", lg: 80 },
                      width: { xs: "100%", sm: 80, lg: "100%" },

                      // Gradient direction changes
                      background: {
                        xs: "linear-gradient(to bottom, rgba(255,255,255,0) 0%, #fff 100%)",
                        sm: "linear-gradient(to right, rgba(255,255,255,0) 0%, #fff 100%)",
                        lg: "linear-gradient(to bottom, rgba(255,255,255,0) 0%, #fff 100%)",
                      },
                    }}
                  /> */}
                </Box>
                {canEditOwnProfile && (
                  <IconButton
                    size="small"
                    sx={{
                      position: "absolute",
                      top: 12,
                      right: 12,
                      bgcolor: "#f0f0f0",
                      "&:hover": { bgcolor: "#e0e0e0" },
                    }}
                    onClick={() =>
                      navigate(`/profile/update/${userId}`, {
                        state: { mode: "update" },
                      })
                    }
                  >
                    <Edit fontSize="small" color="primary" />
                  </IconButton>
                )}
                {/* 
                <Box
                  position="relative"
                  display="inline-block"
                  mb={2}
                  sx={{

                    animation: "pulse 2s infinite",
                    "@keyframes pulse": {
                      "0%": { boxShadow: "0 0 0 0 rgba(0,100,122,0.4)" },
                      "70%": { boxShadow: "0 0 0 10px rgba(0,100,122,0)" },
                      "100%": { boxShadow: "0 0 0 0 rgba(0,100,122,0)" },
                    },
                    borderRadius: "50%",
                    justifyContent: "center"
                  }}
                >
                    <Avatar
                      // src={image}
                      sx={{
                        width: 100,
                        height: 100,
                        border: "4px solid #00647A30",
                        cursor: "pointer",
                        transition: "transform 0.2s ease-in-out",
                        "&:hover": { transform: "scale(1.05)" },
                      }}
                      onClick={() =>
                        navigate(`/profile/${userId}`, {
                          state: { mode: "view" },
                        })
                      }
                    />
                  </Box> */}
                <Box
                  sx={{
                    flex: 1,
                    p: { xs: 2, sm: 3, md: 3.5, lg: 4 },
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                >
                  <Typography variant="h6" fontWeight="bold">
                    {userData?.userFirstName
                      ? `${userData.userFirstName} ${userData.userLastName}`
                      : ""}
                  </Typography>
                  <Typography color="primary">{designationText}</Typography>

                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    mt={2}
                    gap={1}
                  >
                    <Email fontSize="small" />
                    <Typography variant="body2">
                      {userData?.emailId || ""}
                    </Typography>
                  </Box>

                  <Button
                    variant="contained"
                    sx={{ mt: 1, width: "100%" }}
                    disabled={!canViewOwnJourney}
                    onClick={
                      isProd ? () => setOpen(true) : () => navigate("/journey")
                    }
                  >
                    View Full Journey
                  </Button>
                </Box>
              </Paper>

              <ButtonBase
                onClick={() => navigate("/dastak/homepage")}
                sx={{
                  width: "100%",
                  mt: 2,
                  p: 2,
                  borderRadius: 3,
                  border: "1px solid #E8D9FF",
                  background:
                    "linear-gradient(135deg, #F8F3FF 0%, #FFF 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  textAlign: "left",
                  transition: "all 0.2s ease",

                  "&:hover": {
                    transform: "translateY(-2px)",
                    boxShadow: "0 8px 24px rgba(120, 70, 180, 0.12)",
                    borderColor: "#C9A6FF",
                  },
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Box
                    component="img"
                    src={DastakLogo}
                    alt="Dastak"
                    sx={{
                      width: 56,
                      height: 56,
                      objectFit: "contain",
                    }}
                  />

                  <Box>
                    <Typography
                      sx={{
                        fontSize: "1rem",
                        fontWeight: 700,
                        color: "#2B2B2B",
                      }}
                    >
                      Visit Dastak
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: "0.85rem",
                        color: "#6B7280",
                        mt: 0.25,
                      }}
                    >
                      Explore programs, resources and updates
                    </Typography>
                  </Box>
                </Box>
              </ButtonBase>
            </Grid>
            <Grid item xs={12} lg={9}>
              {pendingVerification ? null : (
                <motion.div
                  initial={{ x: -20, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ duration: 0.6 }}
                >
                  <Paper
                    sx={{
                      p: 1.5,
                      borderRadius: 3,
                      background: "linear-gradient(to right, #00647A, #00839a)",
                      color: "white",
                      // boxShadow:
                      //   "0 0 12px rgba(0, 255, 255, 0.3), 0 0 20px rgba(0, 255, 255, 0.2) inset",
                      // transition: "box-shadow 0.3s ease-in-out",
                      // "&:hover": {
                      //   boxShadow:
                      //     "0 0 18px rgba(0, 255, 255, 0.4), 0 0 28px rgba(0, 255, 255, 0.3) inset",
                      // },
                    }}
                  >
                    <Typography
                      variant="h5"
                      fontWeight="bold"
                    // sx={{
                    //   textShadow:
                    //     "0 0 3px rgb(209, 255, 255), 0 0 3px rgb(132, 247, 247)",
                    // }}
                    >
                      “Welcome back, leader”
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        opacity: 0.9,
                        mt: 1,
                        transition: "opacity 0.5s ease-in-out",
                      }}
                    >
                      {paragraphs[currentPara]}
                    </Typography>
                  </Paper>
                </motion.div>
              )}

              <Box sx={{ mt: pendingVerification ? 0 : 2.5 }}>
                {/* <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.25 }}>
                  <Typography variant="subtitle1" fontWeight={700} color="text.primary">
                    Priority Actions
                  </Typography>
                  <Box
                    sx={{
                      px: 1,
                      py: 0.25,
                      borderRadius: 10,
                      bgcolor: "rgba(106, 27, 154, 0.08)",
                      color: "#6A1B9A",
                      fontSize: "0.68rem",
                      fontWeight: 700,
                      letterSpacing: "0.06em",
                      textTransform: "uppercase",
                    }}
                  >
                    Quick access
                  </Box>
                </Box> */}

                {/* <Grid container spacing={2}>
                  {priorityActions.map((action, index) => (
                    <Grid item xs={12} sm={6} md={3} lg={isAdmin ? 2.99 : 4} key={action.title}>
                      <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.45, delay: 0.12 * index }}
                        whileHover={action.disabled ? undefined : { y: -5 }}
                        whileTap={action.disabled ? undefined : { scale: 0.98 }}
                        style={{ height: "100%" }}
                      >
                        <Paper
                          role={action.disabled ? undefined : "link"}
                          tabIndex={action.disabled ? -1 : 0}
                          aria-label={`Open ${action.title}`}
                          aria-disabled={action.disabled || undefined}
                          elevation={0}
                          onClick={() => handlePriorityAction(action)}
                          onKeyDown={(event) => {
                            if (
                              !action.disabled &&
                              (event.key === "Enter" || event.key === " ")
                            ) {
                              event.preventDefault();
                              handlePriorityAction(action);
                            }
                          }}
                          sx={{
                            position: "relative",
                            height: "100%",
                            minHeight: 145,
                            py: 2.25,
                            px: 2.5,
                            borderRadius: 3,
                            color: "white",
                            background: action.gradient,
                            opacity: action.disabled ? 0.5 : 1,
                            filter: action.disabled
                              ? "grayscale(0.45)"
                              : "none",
                            cursor: action.disabled ? "not-allowed" : "pointer",
                            overflow: "hidden",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            boxShadow: `0 8px 24px ${action.glow}`,
                            transition: "box-shadow 0.25s ease",
                            "&:hover": {
                              boxShadow: `0 13px 30px ${action.glow}`,
                              "& .priority-action-arrow": {
                                transform: "translateX(4px)",
                              },
                            },
                            "&:focus-visible": {
                              outline: "3px solid rgba(255,255,255,0.9)",
                              outlineOffset: 3,
                            },
                            "&::after": {
                              content: '""',
                              position: "absolute",
                              width: 110,
                              height: 110,
                              borderRadius: "50%",
                              bgcolor: "rgba(255,255,255,0.1)",
                              top: -48,
                              right: -34,
                            },
                          }}
                        >
                          <Box
                            sx={{
                              position: "relative",
                              zIndex: 1,
                              display: "flex",
                              alignItems: "flex-start",
                              justifyContent: "space-between",
                            }}
                          >
                            <Box
                              sx={{
                                width: 44,
                                height: 44,
                                borderRadius: 2.25,
                                bgcolor: "rgba(255,255,255,0.2)",
                                display: "grid",
                                placeItems: "center",
                                backdropFilter: "blur(4px)",
                                "& svg": { fontSize: 25 },
                              }}
                            >
                              {action.icon}
                            </Box>
                            <ArrowForward
                              className="priority-action-arrow"
                              sx={{
                                mt: 0.5,
                                transition: "transform 0.25s ease",
                              }}
                            />
                          </Box>

                          <Box sx={{ position: "relative", zIndex: 1, mt: 2 }}>
                            <Typography
                              sx={{
                                fontSize: "0.68rem",
                                fontWeight: 700,
                                letterSpacing: "0.08em",
                                textTransform: "uppercase",
                                opacity: 0.78,
                                mb: 0.35,
                              }}
                            >
                              {action.eyebrow}
                            </Typography>
                            <Typography
                              variant="subtitle1"
                              fontWeight={700}
                              lineHeight={1.25}
                            >
                              {action.title}
                            </Typography>
                             <Typography
                              variant="body2"
                              sx={{ opacity: 0.82, mt: 0.35 }}
                            >
                              {action.text}
                            </Typography> 
                          </Box>
                        </Paper>
                      </motion.div>
                    </Grid>
                  ))}
                </Grid> */}
              </Box>

              {pendingVerification ? null : (
                <Grid container spacing={2} mt={2}>
                  {visibleCards.map((card, i) => {
                    const isCardRestricted = isRestrictedNECMember && (card.title === "Office-Bearers" || card.title === "Chapters");
                    const isCardClickable =
                      !isCardRestricted &&
                      canViewDashboard &&
                      (!card.modulePermission ||
                        can(
                          card.modulePermission.module,
                          card.modulePermission.subModule,
                          card.modulePermission.action,
                        )) &&
                      (!card.permission || canByKey(card.permission));

                    return (
                      <Grid item xs={12} sm={6} key={i}>
                        <motion.div
                          variants={cardVariants}
                          initial="hidden"
                          animate="visible"
                          whileHover={
                            isCardClickable
                              ? {
                                scale: 1.05,
                                boxShadow: "0 6px 12px rgba(0,0,0,0.15)",
                              }
                              : undefined
                          }
                          whileTap={
                            isCardClickable ? { scale: 0.97 } : undefined
                          }
                          style={{
                            borderRadius: "24px",
                            overflow: "hidden",
                          }}
                        >
                          <Paper
                            sx={{
                              p: { xs: 2, sm: 2, md: 4 },
                              borderRadius: "24px",
                              display: "flex",
                              gap: 1.5,
                              alignItems: "center",
                              bgcolor: card.bg,
                              cursor: isCardClickable
                                ? "pointer"
                                : "not-allowed",
                              transition: "0.3s ease",
                              overflow: "hidden",
                              opacity: isCardClickable ? 1 : 0.65,
                            }}
                            onClick={() =>
                              isCardClickable && handleModuleClick(() => navigate(card.path))
                            }
                          >
                            <Tooltip title={card.title} arrow>
                              <Box
                                sx={{
                                  width: 70,
                                  height: 70,
                                  borderRadius: "30px",
                                  background: card.iconBg,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  mr: 1.5,
                                  boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
                                  transition:
                                    "transform 0.18s cubic-bezier(.4,2,.6,1), box-shadow 0.18s",
                                  "&:hover": {
                                    transform: "scale(1.2) rotate(-10deg)",
                                    boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
                                  },
                                }}
                              >
                                {card.icon}
                              </Box>
                            </Tooltip>
                            <Box>
                              <Typography
                                variant="h6"
                                fontWeight="bold"
                                sx={{
                                  color: "#2E2E2E",
                                  letterSpacing: "0.5px",
                                  mb: 0.3,
                                  transition: "color 0.3s ease",
                                  "&:hover": { color: "#1565C0" },
                                }}
                              >
                                {" "}
                                {card.title}
                              </Typography>
                              <Typography
                                variant="body2"
                                color="text.secondary"
                                fontSize="0.95rem"
                              >
                                {card.text}
                              </Typography>
                            </Box>
                          </Paper>
                        </motion.div>
                      </Grid>
                    );
                  })}
                </Grid>
              )}
            </Grid>
          </Grid>
        </Box>
      </Box>

      <OfflineModal
        open={offlineBannerOpen}
        onClose={() => setOfflineBannerOpen(false)}
      />

      <Dialog
        open={chapterDialogOpen}
        onClose={closeChapterDialog}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: { borderRadius: 3, overflow: "hidden" },
        }}
      >
        <DialogTitle
          sx={{
            py: 1,
            px: { xs: 2, sm: 3, md: 4 },
            position: "relative",
          }}
        >
          <IconButton
            onClick={closeChapterDialog}
            sx={{
              position: "absolute",
              right: 4,
              top: 0,
              color: "#64748B",

              "&:hover": {
                background: "#F1F5F9",
              },
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>

          <Typography
            sx={{
              fontSize: "18px !important",
              fontWeight: 700,
              color: "#111827",
              textAlign: "center",
            }}
          >
            Chapter Memberships
          </Typography>
          <Typography
            sx={{
              fontSize: "1.5rem",
              fontWeight: 400,
              color: "#323333",
              textAlign: "center",
            }}
          >
            You are currently part of the below list of chapters.
          </Typography>
        </DialogTitle>

        <DialogContent dividers sx={{ p: 2, bgcolor: "#FAFBFC" }}>
          {isChapterMembershipLoading ? (
            <Box
              display="flex"
              justifyContent="center"
              py={5}
            >
              <CircularProgress />
            </Box>
          ) : hasChapterMembership &&
            assignedChapters.length > 0 ? (
            <Box
              sx={{
                border: "1px solid #E5E7EB",
                borderRadius: 3,
                bgcolor: "#fff",
                overflow: "hidden",
              }}
            >
              {assignedChapters.map((chapter, index) => (
                <Box key={chapter._id}>
                  <Box
                    sx={{
                      p: 2,
                      display: "flex",
                      flexDirection: { xs: "column", sm: "row" },
                      justifyContent: "space-between"
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 600,
                        color: "#111827",
                        fontSize: "1rem",
                      }}
                    >
                      {chapter.chapterName || chapter.name}
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: "0.9rem",
                        color: "#64748B",
                      }}
                    >
                      {[
                        chapter?.location?.district?.districtName,
                        chapter?.location?.state?.stateName,
                      ]
                        .filter(Boolean)
                        .join(", ") || "Location unavailable"}
                    </Typography>
                  </Box>

                  {index !== assignedChapters.length - 1 && (
                    <Divider />
                  )}
                </Box>
              ))}
            </Box>
          ) : (
            <Alert severity="info">
              No chapter memberships found.
            </Alert>
          )}
        </DialogContent>
        {/* ACTION BUTTON */}
        <DialogActions
          sx={{
            p: 3,
            pt: 2,
            borderTop: "1px solid #F1F5F9",
          }}
        >
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <FormControl component="fieldset">
              <Typography
                sx={{
                  fontSize: "1.5rem",
                  fontWeight: 400,
                  color: "#323333",
                  textAlign: "center",
                }}
              >
                You can join an existing chapter or create a new chapter.
              </Typography>
              <RadioGroup
                row
                value={chapterMode}
                onChange={(e) =>
                  handleModeChange(e.target.value)
                }
                sx={{
                  justifyContent: "center",
                  gap: 2,
                }}
              >
                <FormControlLabel
                  value="join"
                  control={<Radio />}
                  label="Join Existing Chapter"
                />

                <FormControlLabel
                  value="create"
                  control={<Radio />}
                  label="Create New Chapter"
                />
              </RadioGroup>
            </FormControl>

            <Button
              variant="contained"
              disabled={actionConfig.disabled}
              onClick={actionConfig.action}
              sx={{
                py: 1.25,
                borderRadius: 2,
                textTransform: "none",
                fontWeight: 600,
              }}
            >
              {actionConfig.label}
            </Button>
          </Box>
        </DialogActions>

        {/* SNACKBAR */}
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={4000}
          onClose={() => setSnackbarOpen(false)}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <MuiAlert
            elevation={6}
            variant="filled"
            severity="success"
            onClose={() => setSnackbarOpen(false)}
          >
            {snackbarMessage}
          </MuiAlert>
        </Snackbar>
      </Dialog>
    </motion.div>
  );
}
